import Page, { getProps } from '@/modules/media/album/slug'

export const getServerSideProps = getProps

export default Page
